import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {translate} from '@flowww/design-system';

@Component({
    selector: 'app-separator',
    templateUrl: './separator.component.html',
    styleUrls: ['./separator.component.scss'],
    standalone: false
})
export class SeparatorComponent implements OnInit {
    ngOnInit(): void {
    }
}
